import { connect } from 'react-redux'
import MyProfileComponent from '../components'
import { getMyProfileInfo, updateMyProfileInfo, verifyEmailAddress } from '../actions/apiRequest'

import '../styles/index.scss'
import { getCountries } from '../../Account/actions/allCountries'

const mapStateToProps = (state) => ({
  disableInputFeild: state.forgotPassword.visible,
  profileData: state.profile.info,
  apiActionFeedback: state.profile.actionFeedback,
  countriesOption: state.merchantCountries.allCountries,
  customerEmailExists: state.profile.customerEmailExists,
  emailVerificationInProgess: state.profile.emailVerificationInProgess,
})

const mapDispatchToProps = (dispatch) => ({
  verifyEmail: (email) => {
    dispatch(verifyEmailAddress(email))
  },
  fetchProfileData: () => {
    dispatch(getMyProfileInfo())
    dispatch(getCountries())
  },
  onClickSave: (infos) => {
    dispatch(updateMyProfileInfo(infos))
  },
})

const MyProfile = connect(mapStateToProps, mapDispatchToProps)(MyProfileComponent)

export default MyProfile
